import { unique } from 'radash'
import type { UserInfoResponseData } from '@atbay/new-stance-aggregator-node-sdk'

export function transformUsers(
    users: UserInfoResponseData[] = []
): TAssetUser[] {
    return users.map((user) => ({
        id: user.id,
        hostname: user.hostname,
        asset_type: user.asset_type as TAssetType,
        firstName: user.first_name ?? undefined,
        lastName: user.last_name ?? undefined,
        department: user.department ?? undefined,
        username: user.username ?? undefined,
        status: user.status ?? undefined,
        userType: user.user_type ?? undefined,
        integrationId: user.integration_id ?? undefined,
        jobTitle: user.job_title ?? undefined,
        mobilePhone: user.mobile_phone ?? undefined,
        mfaEnabled: user.mfa_enabled ?? undefined,
        mfaType: user.mfa_type ?? undefined,
        lastPasswordChangeAt: user.last_password_change_at ?? undefined,
        issues: user.issues as TAssetUser['issues'],
    }))
}

export function transformAssets(assets: TAsset[]): TAsset[] {
    return assets.map((asset) => {
        return {
            ...asset,
            hostname: asset.hostname,
            issues: ([...(asset?.issues ?? [])] as typeof asset.issues)
                ?.sort((a, b) => a.name?.localeCompare(b.name))
                ?.sort((a, b) => a.severity?.localeCompare(b.severity)),
            open_ports: unique(
                (asset.open_ports as TAssetOpenPort[]) || [],
                (a) => a.port_number
            ),
        }
    })
}
